import { Injectable } from '@angular/core';
import { UserGroup } from '../models/user-group.model';

@Injectable()
export class UserGroupsBulkUserAddService {
  public group: UserGroup;
  public userEmailsToCheck: string[] = [];
}
